// @flow
import * as R from "ramda"

import { TAB_TYPES } from "common/consts/account"

export const getDeepLink = (link: string) => (R.values(TAB_TYPES).includes(link) ? link : "")
